import React from 'react'
import { useSelector } from 'react-redux'

import { CustomTheme } from '@masfront/common-b2c'

import { Box, Typography, makeStyles } from '@material-ui/core'

import { selectCustomerInformation } from './Sidebar.selectors'

const useStyles = makeStyles(({ palette, name }: CustomTheme) => ({
  personal: {
    backgroundColor: name === 'masmovil' ? palette.grey[700] : palette.primary.dark,
    color: palette.grey[50],
  },
  name: {
    textTransform: 'capitalize',
  },
}))

export default function SidebarCustomerInfo() {
  const { personal, name } = useStyles()

  const customer = useSelector(selectCustomerInformation)

  return (
    <Box width="312px" px={6} py={6} color="white" className={personal}>
      <Typography className={name} variant="subtitle2">
        {customer || 'Titular'}
      </Typography>
      <Box fontStyle={customer ? 'normal' : 'italic'} mt={2}>
        <Typography variant="body2">{customer ? 'TITULAR' : 'Sin datos todavía'}</Typography>{' '}
      </Box>
    </Box>
  )
}
